import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';

import { BACKEND_URL } from '../config/api';

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      const hash = location.hash;
      const sessionId = hash.split('session_id=')[1]?.split('&')[0];

      if (!sessionId) {
        toast.error('Invalid session');
        navigate('/login');
        return;
      }

      try {
        const response = await axios.get(
          `${BACKEND_URL}/api/auth/google/session`,
          {
            headers: { 'X-Session-ID': sessionId },
            withCredentials: true
          }
        );

        toast.success('Login successful!');
        
        if (response.data.user_type === 'tradesperson') {
          navigate('/tradesperson/dashboard', { state: { user: response.data } });
        } else if (response.data.user_type === 'employer') {
          navigate('/employer/dashboard', { state: { user: response.data } });
        } else if (response.data.user_type === 'admin') {
          navigate('/admin/dashboard', { state: { user: response.data } });
        }
      } catch (error) {
        toast.error('Authentication failed');
        navigate('/login');
      }
    };

    processSession();
  }, [location, navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 flex items-center justify-center" data-testid="auth-callback-loader">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-500 mx-auto mb-4"></div>
        <p className="text-slate-600">Authenticating...</p>
      </div>
    </div>
  );
}
